module.exports = __webpack_public_path__ + "static/InnerRender-bfbb323000379ae02badbea9ec7e5601.jpg";